export const prompts = [
  [
    "Billionaire / Secret Heir",
    "A secret billionaire heir falls in love with his biggest rival’s assistant...",
  ],
  [
    "K-Pop / Fanfiction",
    "A backstage mix-up forces a normal fan into a fake-dating contract with a global idol...",
  ],
  [
    "Dark Romance / Syndicate",
    "An undercover detective gets forced into an arranged marriage with the mob boss’s daughter...",
  ],
  [
    "True Crime / Mystery",
    "A true-crime podcaster uncovers a 10-year-old cold case connected to her own family...",
  ],
  [
    "Supernatural / Werewolf",
    "A rejected alpha’s mate discovers she is the true heir to the throne...",
  ],
  [
    "Enemies to Lovers",
    "Two rival academic prodigies are forced to co-direct an 80-episode series...",
  ],
  [
    "Revenge / High Stakes",
    "A framed CEO returns five years later under a new identity to take back her empire...",
  ],
  [
    "Wattpad / Fanfiction Import",
    "Turn my 30-chapter Wattpad manuscript into an 80-episode vertical drama with cliffhangers...",
  ],
  [
    "Sci-Fi / Synthetic",
    "A rogue AI hacker generates a synthetic replica of her missing sister, but it remembers too much...",
  ],
  [
    "Nordic Noir / Thriller",
    "A detective in Copenhagen investigates a series of high-fashion murders tied to an elite family...",
  ],
] as const;

export const creators = [
  {
    image: "creator-mira.png",
    name: "Mira Vale",
    genre: "Romance · Slow burn",
    bio: "Writes complicated love stories, impossible choices and the kind of endings that demand another episode.",
    className: "mira",
  },
  {
    image: "creator-hana.png",
    name: "Hana Park",
    genre: "Fanfiction · Coming of age",
    bio: "Turns fandom what-ifs into character-led stories about first love, found family and life behind the spotlight.",
    className: "hana",
  },
  {
    image: "creator-amara.png",
    name: "Amara Cole",
    genre: "Mystery · Psychological thriller",
    bio: "Builds tense, intimate mysteries where every secret changes the story and no one is quite who they seem.",
    className: "amara",
  },
] as const;
